<template>
<div class="person__form__fields text-left">
	<div class="row">
		<div class="col-3">
			<b-form-group :label="`${$t('person.salutation')}:`">
				<b-form-select v-model="form.salutation"
				               :options="salutations" />
			</b-form-group>
		</div>
	</div>

	<div class="row">
		<div class="col-3">
			<b-form-group :label="`${$t('person.firstName')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.first_name">
				</b-form-input>
			</b-form-group>
		</div>

		<div class="col">
			<b-form-group :label="`${$t('person.lastNamePrefix')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.last_name_prefix">
				</b-form-input>
			</b-form-group>
		</div>

		<div class="col">
			<b-form-group :label="`${$t('person.lastName')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.last_name">
				</b-form-input>
			</b-form-group>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<b-form-group :label="`${$t('person.company')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.company">
				</b-form-input>
			</b-form-group>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<b-form-group :label="`${$t('person.email')}:`">
				<b-form-input type="email"
				              v-model="form.email"
							  autocomplete="off">
							  <!-- :disabled="form.no_email" -->
				</b-form-input>
			</b-form-group>
		</div>

		<div class="col">
			<b-form-group :label="`${$t('item.itemNumber')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.code">
				</b-form-input>
			</b-form-group>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<b-form-group :label="`${$t('person.mobile')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.mobile">
				</b-form-input>
			</b-form-group>
		</div>

		<div class="col">
			<b-form-group :label="`${$t('person.telephone')}:`">
				<b-form-input type="text"
							  autocomplete="off"							  
				              v-model="form.telephone">
				</b-form-input>
			</b-form-group>
		</div>
	</div>

	<div class="row" v-if="mode == 'add'">
		<div class="col">
			<b-form-checkbox v-model="form.no_email"
							 :unchecked-value="false">
			{{ `${$t('person.noEmail')}` }}
			</b-form-checkbox>
		</div>
	</div>

	<hr>

	<b-form-group :label="`${$t('person.address')}:`">
		<b-form-input type="text"
					  autocomplete="off"					 
		              v-model="form.address">
		</b-form-input>
	</b-form-group>

	<div class="row">
		<div class="col">
			<b-form-group :label="`${$t('person.zipcode')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.zipcode">
				</b-form-input>
			</b-form-group>
		</div>
		<div class="col">
			<b-form-group :label="`${$t('person.city')}:`">
				<b-form-input type="text"
							  autocomplete="off"
				              v-model="form.city">
				</b-form-input>
			</b-form-group>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<b-form-group :label="`${$t('person.country')}:`">
				<b-form-select v-model="form.country"
				               :options="countryList" />
			</b-form-group>
		</div>
	</div>
	
	<hr>

	<div class="row">
		<div class="col">
			<b-form-group :label="`${$t('person.iban')} (${form.country}):`">
				<the-mask class="form-control"
				          mask="XXXX XXXX XXXX XXXX XXXX XXXX XXXX"
				          v-model="form.bank_account_number" />
			</b-form-group>
		</div>
	</div>

	<template v-if="form.bank_account_number">
		<div class="row">
			<div class="col">
				<b-form-group :label="`${$t('person.accountName')}:`">
					<b-form-input v-model="form.bank_account_name" type="text" autocomplete="off" />
				</b-form-group>
			</div>
		</div>
	</template>

	<template v-if="form.country != 'NL' && form.country != ''">
		<div class="row">
			<div class="col">
				<b-form-group :label="`${$t('person.bic')}:`">
					<b-form-input v-model="form.bic" type="text" autocomplete="off" />
				</b-form-group>
			</div>
		</div>
	</template>

	<div class="row">
		<div class="col">
			<b-form-checkbox v-model="form.cash"
							 :unchecked-value="false">
			{{ `${$t('person.cash')}` }}
			</b-form-checkbox>
		</div>
	</div>

	<hr>

	<b-form-group :label="`${$t('person.invoiceEmails')}:`">
		<b-form-input type="text"
					  autocomplete="off"
					  v-model="form.invoice_emails">
		</b-form-input>
	</b-form-group>

	<b-form-group :label="`${$t('person.note')}:`">
		<b-form-textarea v-model="form.note"
						:rows="3"
						:max-rows="6">
		</b-form-textarea>
	</b-form-group>

	<b-form-checkbox v-if="!hideAdmin"
	                 v-model="form.is_admin"
	                 :value="true"
	                 :unchecked-value="false">
		{{ $t('person.userIsAdmin') }}
	</b-form-checkbox>
</div>
</template>
<script>
import { TheMask } from 'vue-the-mask'

export default {
	components: {
		TheMask,
	},
	name: 'PersonFormFields',
	props: {
		form: {
			type: Object,
			required: true
		},
		hideAdmin: {
			type: Boolean,
			default: true
		},
		countryList: {
			type: Array,
		},
		mode: {
			type: String,
		}
	},
	data: () => ({
		salutations: [
			'',
			'Mevrouw',
			'De heer',
			'Familie',
			'Erven',
		],
	}),
	watch: {
		form: {
			handler: function(val, oldVal) {
				this.$emit('update:form', val);
			},
			deep: true
		},
		'form.bank_account_number': function(value) {
			this.form.bank_account_number = this.form.bank_account_number.toUpperCase();
		},
	}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PersonFormFields.vue?cb0b7ef8